module.exports = __webpack_public_path__ + "media/packs/images/flags/TW-7418da3517798fc9e4fff63e4103b10a.png";